import React from 'react';
import { ExternalLink } from 'lucide-react';
import { Button } from './ui/Button';
export function HeroSection() {
  return <section className="bg-[#00897B] py-12 md:py-20 px-4 text-center relative overflow-hidden" data-id="element-125">
      {/* Decorative pattern overlay could go here */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10 pointer-events-none" data-id="element-126"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-127">
        <h1 className="text-3xl md:text-5xl font-bold text-white mb-4 tracking-tight" data-id="element-128">
          Free Classifieds in Singapore
        </h1>
        <p className="text-teal-100 text-lg md:text-xl mb-8 max-w-2xl mx-auto" data-id="element-129">
          Buy, sell, find jobs, and meet people near you. Simple, safe, and
          free.
        </p>

        <a href="https://www.geylang777-2.site" target="_blank" rel="noopener noreferrer" data-id="element-130">
          <Button variant="orange" size="lg" className="h-14 px-10 text-lg font-semibold shadow-lg gap-3" data-id="element-131">
            <ExternalLink className="h-5 w-5" data-id="element-132" />
            Enter Website
          </Button>
        </a>

        <div className="mt-6 flex flex-wrap justify-center gap-3 text-sm text-teal-100" data-id="element-133">
          <span className="opacity-70" data-id="element-134">Popular:</span>
          <a href="#" className="hover:text-white underline decoration-teal-300/50 underline-offset-4" data-id="element-135">
            iPhone 15
          </a>
          <a href="#" className="hover:text-white underline decoration-teal-300/50 underline-offset-4" data-id="element-136">
            Part-time Jobs
          </a>
          <a href="#" className="hover:text-white underline decoration-teal-300/50 underline-offset-4" data-id="element-137">
            HDB for Rent
          </a>
          <a href="#" className="hover:text-white underline decoration-teal-300/50 underline-offset-4" data-id="element-138">
            Used Cars
          </a>
        </div>
      </div>
    </section>;
}